"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoomiOrderCancelPaymentFailureSchema = void 0;
const boomi_order_default_1 = require("./boomi-order-default");
const EVENT_INFO_DEFINITION = {
    properties: {
        isTrial: {
            type: 'boolean'
        },
        autoRenewStatus: {
            type: 'boolean'
        },
        gracePeriodExpires: {
            type: 'string',
            minLength: 10
        }
    },
    required: [
        'isTrial',
        'autoRenewStatus',
        'gracePeriodExpires'
    ],
    type: 'object'
};
const EVENT_INFO_PROPERTY = {
    $ref: '#/definitions/EventInfo'
};
const EVENT_TYPE_DEFINITION = {
    enum: [
        'CANCELED_VIA_PAYMENT_FAILURE',
    ],
    type: 'string'
};
const EVENT_TYPE_PROPERTY = {
    $ref: '#/definitions/EventType'
};
exports.BoomiOrderCancelPaymentFailureSchema = {
    ...boomi_order_default_1.BoomiOrderDefaultSchema,
    definitions: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.definitions,
        EventInfo: EVENT_INFO_DEFINITION,
        EventType: EVENT_TYPE_DEFINITION,
    },
    properties: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.properties,
        eventInfo: EVENT_INFO_PROPERTY,
        eventType: EVENT_TYPE_PROPERTY,
    }
};
//# sourceMappingURL=data:application/json;base64,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